import React, { Component } from "react";
import { connect } from "react-redux";
import veg from "./image/veg.png";
import nveg from "./image/nveg.png";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import * as handler from "../Actions/main";
import Box from "@material-ui/core/Box";

import "./item.css";
const useStyles = theme => ({
  root: {
    padding: theme.spacing(3, 2)
  },
  button: {
    margin: theme.spacing(1)
  }
});
class EachItem extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    let current = this.props.menu.itemId;
    // console.log(nextProps);
    // console.log(current);

    if (nextProps.lastItemClicked === current) {
      return true;
    } else if (nextProps.lastItemClicked === null && nextProps.cartDup[current])
      return true;
    else if (
      nextProps.lastItemClicked === null &&
      nextProps.isSwitch &&
      nextProps.menu.itemId !== current
    )
      return true;
    else return false;
  }

  render() {
    let flagv = 0;
    let type;
    console.log("rendered");
    for (let i = 0; i < this.props.menu.additionalTags.length; i++) {
      if (this.props.menu.additionalTags[i] === "Veg") flagv = 1;
    }

    if (flagv === 1) type = veg;
    else type = nveg;

    let x = ["sc"].join(" ");
    let xs = (
      <Paper className={x} style={{ padding: 10, minWidth: "150px" }}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Box
              display="flex"
              flexDirection="row"
              p={1}
              bgcolor="background.paper"
            >
              <Box>
                <img src={type} alt="type" />
              </Box>
              <Box p={1}>
                <span style={{ fontWeight: "bold" }}>
                  {this.props.menu.itemName}
                </span>
              </Box>
            </Box>

            <div style={{ overflowWrap: "break-word", color: "#999999" }}>
              {this.props.menu.description}
            </div>
          </Grid>

          <Grid item xs={4}>
            <Typography
              variant="body1"
              align="center"
              style={{ fontWeight: "bold" }}
            >
              ₹{this.props.menu.PriceMap.TotalPrice}
            </Typography>

            {this.props.cart[this.props.menu.itemId] !== undefined ? (
              // (<Box display="flex" flexDirection="row" bgcolor="background.paper" style={{overflow:"auto"}}>
              // <Box><Button variant="contained"  className={classes.button} size="small" style={{color:'black',backgroundColor:"#f2efef",minWidth:'21px'}}    onClick={this.props.click2}>
              // {/* <img src={add} alt="add"></img> */}+
              // </Button>
              // </Box>

              // <Box style={{paddingTop:5,fontSize:25}} className="sudo">
              // {this.props.cart[this.props.menu.itemId + "naruto"].quantity}
              // </Box>

              // <Box>
              // <Button size="small" variant="contained" className={classes.button}   style={{color:'black',backgroundColor:"#feffef",minWidth:'21px'}}

              // onClick={this.props.del}>
              // {/* <img src={minus} alt="minus"></img> */}-
              // </Button>
              // </Box>

              // </Box>
              <Box
                style={{
                  padding: 1,
                  marginLeft: 1,
                  marginRight: 10,
                  maxWidth: "120px",
                  marginBottom: "5px"
                }}
              >
                <Grid
                  container
                  alignItems="center"
                  style={{
                    border: "1px solid green",
                    backgroundColor: "white"
                  }}
                  spacing={1}
                >
                  <Grid item xs={4}>
                    <Typography
                      onClick={() => this.props.del(this.props.menu.itemId)}
                      align="center"
                      color="textSecondary"
                      variant="h5"
                    >
                      <span style={{ fontSize: "18px" }}>-</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      align="center"
                      color="textSecondary"
                      variant="h5"
                    >
                      <span style={{ fontSize: "18px" }}>
                        {this.props.cart[this.props.menu.itemId].quantity}
                      </span>
                    </Typography>
                  </Grid>

                  <Grid item xs={4}>
                    <Typography
                      onClick={() => this.props.click2(this.props.menu.itemId)}
                      align="center"
                      color="textSecondary"
                      variant="h5"
                    >
                      <span style={{ fontSize: "18px" }}>+</span>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            ) : (
              <Button
                size="small"
                variant="contained"
                style={{
                  color: "white",
                  backgroundColor: "green"
                }}
                onClick={() => this.props.click2(this.props.menu.itemId)}
              >
                <span className="CartButton">ADD to Cart</span>
              </Button>
            )}
          </Grid>
        </Grid>
      </Paper>
    );
    return xs;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    click2: itemId => dispatch(handler.addItem(itemId)),
    del: itemId => dispatch(handler.deleteItem(itemId))
  };
};
const mapStateToProps = state => {
  return {
    cart: state.menuR.cart,
    lastItemClicked: state.menuR.lastItemClicked,
    cartDup: state.menuR.cartDup,
    isSwitch: state.menuR.isSwitch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(EachItem));
